// Web-compatible types using basic syntax
type ValueOf<T> = T[keyof T];

export const AvatarGradientColor = {
	Red: 'Red',
	Blue: 'Blue',
	Gold: 'Gold',
} as const;
export type AvatarGradientColor = ValueOf<typeof AvatarGradientColor>;

export const AvatarSparklePosition = {
	Left: 'Left',
	Right: 'Right',
} as const;
export type AvatarSparklePosition = ValueOf<typeof AvatarSparklePosition>;

export const AvatarLevelPosition = {
	TopRight: 'TopRight',
	MiddleRight: 'MiddleRight',
} as const;
export type AvatarLevelPosition = ValueOf<typeof AvatarLevelPosition>;
